var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"special-plus"}},_vm._l((_vm.matchIds),function(matchId,index){return _c('div',{key:matchId,staticClass:"grid-left"},[_c('match',{attrs:{"id-match":matchId,"colored-id":index % 2 === 1}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }